<template>
	<div
	v-if="deliver === 1 && delivery_days.length"
	class="checkout-section">
		<h2 class="checkout-section__title">
			<i class="bi bi-calendar-event"></i>
			¿Qué día te lo llevamos?
		</h2>

		<div class="checkout-field">
			<b-select
			:options="options"
			v-model="fecha_entrega"></b-select>
		</div>
	</div>
</template>
<script>
export default {
	created() {
        this.$store.dispatch('delivery_day/getModels')
		// this.get_delivery_days()
	},	
	computed: {
		// Metodo de entrega elegido en Deliver.vue: 1 = envio a domicilio, 0 = retiro por local
		deliver() {
			return this.$store.state.cart.cart.deliver
		},
		fecha_entrega: {
			get() {
				// Valor persistido dentro del carrito en el store
				let fecha_entrega = this.$store.state.cart.cart.fecha_entrega
				if (!fecha_entrega) {
					return 0
				}
				return fecha_entrega
			},
			set(value) {
				console.log(value)
				this.$store.commit('cart/set_fecha_entrega', value)
			}
		},	
		delivery_days() {
			return this.$store.state.delivery_day.models
		},
		options() {
			let options = [{
				value: 0,
				text: 'Seleccione el dia de entrega'
			}]
			this.delivery_days.forEach(day => {
				options.push({
					value: day.value,
					text: day.label
				})
			})
			return options
		}
	},
	methods: {
		get_delivery_days() {
			this.$api.get('delivery-day/'+this.commerce.id)
			.then(res => {
				this.delivery_days = res.data.models 
			})
		}
	}
}
</script>
